import "core-js/modules/es6.function.name";
import SelectLocalLoadComponent from "./index.vue";
var SelectLocalLoad = {
  install: function install(Vue) {
    Vue.component(SelectLocalLoadComponent.name, SelectLocalLoadComponent);
  },
  key: SelectLocalLoadComponent.name
};
export default SelectLocalLoad;